
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course-builder",
      function () {
        return require("private-next-pages/course-builder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course-builder"])
      });
    }
  